import Container from '@components/container';
import { Button, ContainerSize } from '@lib/types';

export type ButtonSectionProps = {
  data: Button;
};

export default function ButtonSection({ data: { links } }: ButtonSectionProps) {
  return (
    <div className="-my-8 md:-my-12">
      <Container size={ContainerSize.wide}>
        <div className="grid grid-cols-12 gap-1.5 md:gap-6 relative">
          <div
            className={`col-start-2 col-span-10 lg:col-start-4 lg:col-span-6 flex gap-3`}>
            {links.map((link, index) => (
              <a
                key={index}
                className="text-blue-100 text-13 leading-140 tracking-8 bg-blue-400 px-5 py-2.5 rounded-full font-bold uppercase"
                href={link.url}>
                {link.text}
              </a>
            ))}
          </div>
        </div>
      </Container>
    </div>
  );
}
